import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MunilyAreaPictureUploaderSize, MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS } from './area-picture-uploader.types';

@Component({
  selector: 'common-area-picture-uploader',
  templateUrl: './area-picture-uploader.component.html',
  styleUrls: ['./area-picture-uploader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaPictureUploaderComponent {
  @Input() imageUrl: string | undefined = undefined;
  @Input() size: MunilyAreaPictureUploaderSize = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.size;
  @Input() alt: string = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.alt;
  @Input() disabled: boolean = MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS.disabled;
  /** Marca visual tipo "selected" + check_circle (ej. foto principal). */
  @Input() selected: boolean = false;
  @Input() showReplaceOption: boolean = true;
  @Input() showSetPrimaryOption: boolean = true;
  @Input() showDeleteOption: boolean = true;

  @Output() upload = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() menuAction = new EventEmitter<'replace' | 'setPrimary' | 'delete'>();

  constructor(private readonly sanitizer: DomSanitizer) {}

  // Angular sanitiza URLs en [src]; blob:/data: locales hay que marcarlas como seguras.
  get safeImageSrc(): string | SafeUrl {
    const url = this.imageUrl;
    if (!url) {
      return '';
    }
    if (url.startsWith('blob:') || url.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return url;
  }

  get isFilled(): boolean {
    return !!this.imageUrl;
  }

  onContainerClick(): void {
    if (!this.disabled && !this.isFilled) {
      this.upload.emit();
    }
  }

  onRemoveClick(): void {
    if (!this.disabled) {
      this.remove.emit();
    }
  }

  onMenuAction(action: 'replace' | 'setPrimary' | 'delete'): void {
    if (!this.disabled) {
      this.menuAction.emit(action);
    }
  }
}
